import { Row, Col } from 'react-bootstrap';
import Header from '../../../ntisui/Molecules/Header';
import { headerConstants } from '../../../../constants/Constants';
import {
  ButtonType,
  ButtonVariant,
  IdTokenClaims,
  IRenderHeaderProps,
  LoginType,
} from '../types/IHeader';
import { RootStore } from '../../../../store';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { feedConstants } from '../../../../constants/DataFeed';
import userIcon from '../../../../assets/images/login-user-icon.svg';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import { configureMap } from '../../../../config/AppConfig';
import { litrals } from '../../../../constants/Litrals';

const RenderHeader = (props: IRenderHeaderProps) => {
  const [datafeedStatus, setDatafeedStatus] = useState(false);
  const [displayName, setDisplayName] = useState('');
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [msalData, setMsalData] = useState<any>({});
  const datafeedFormStatus: any = useSelector<RootStore>((state) =>
    state.isDatafeedFormChange
      ? state.isDatafeedFormChange.dataFeedStatus
      : false,
  );
  const history = useHistory();
  const location = useLocation();
  const match = matchPath(location.pathname, {
    path: datafeedFormStatus.editfeedPage,
    exact: true,
    strict: false,
  });
  useEffect(() => {
    setDatafeedStatus(datafeedFormStatus.isDatafeedFormChange);
    match == null && setDatafeedStatus(false);
  }, [datafeedFormStatus.isDatafeedFormChange, match]);

  const confirmAction = () => {
    const confirmAction = confirm(feedConstants.promptMsg);
    if (confirmAction) {
      instance.logoutRedirect();
    }
  };
  useEffect(() => {
    let isMounted = false;
    configureMap().then((result) => {
      if (isMounted) return;
      setMsalData(result);
    });
    return () => {
      isMounted = true;
    };
  }, []);
  useEffect(() => {
    let userName = '';
    const profileEditName = msalData.B2C_Edit_Profile_Name;
    if (accounts.length > 1) {
      accounts.map((account) => {
        const idTokenClaims = (
          account.idTokenClaims as unknown as IdTokenClaims
        ).tfp;
        if (idTokenClaims === profileEditName) {
          userName = (account.idTokenClaims as unknown as IdTokenClaims)
            .extension_FirstName;
        }
      });
    } else if (accounts.length === 1) {
      const acc = accounts[0];
      userName = (acc.idTokenClaims as unknown as IdTokenClaims)
        .extension_FirstName;
    }
    setDisplayName(userName);
  }, [accounts, msalData]);

  /**
   * Handle SignIn, SignUp and Logout
   * @param loginType
   */
  const handleLogin = (loginType: string) => {
    if (
      loginType === LoginType.Signin &&
      inProgress === InteractionStatus.None &&
      !isAuthenticated
    ) {
      const loginRequest = {
        scopes: [msalData.B2C_Scope],
      };
      instance.loginRedirect(loginRequest).catch((error) => {
        console.log(error);
        return;
      });
    } else if (
      loginType === LoginType.Signup &&
      inProgress === InteractionStatus.None &&
      !isAuthenticated
    ) {
      const signUpRequest = {
        scopes: [msalData.B2C_Scope],
        authority: msalData.B2C_SignUp,
      };
      instance.loginRedirect(signUpRequest).catch(() => {
        return;
      });
    } else if (loginType === LoginType.Logout) {
      if (!datafeedStatus) {
        instance.logoutRedirect();
      } else {
        confirmAction();
      }
    }
  };
  /**
   * Handle Profile Editing
   */
  const handleProfile = () => {
    const updateProfileRequest = {
      scopes: [msalData.B2C_Scope],
      authority: msalData.Edit_Profile,
    };
    instance.loginRedirect(updateProfileRequest).catch((error) => {
      console.log(error);
      return;
    });
  };
  /**
     /**
   * Handle Profile Editing
   */
  const handleChangePassword = () => {
    const updatePasswordRequest = {
      scopes: [msalData.B2C_Scope],
      authority: msalData.B2C_1_Reset_Password,
    };
    instance.loginRedirect(updatePasswordRequest).catch((error) => {
      console.log(error);
      return;
    });
  };

  /* B2C Register, Signup, Logout and Profile edit buttons
   */
  const buttonArray = [
    {
      label: ButtonType.Logout,
      variant: ButtonVariant.Primary,
      className: 'btn-logout',
      buttonIndex: 2,
      onClick: () => {
        handleLogin(LoginType.Logout);
      },
    },
  ];
  const buttonArray2 = [
    {
      label: ButtonType.Register,
      variant: ButtonVariant.Primary,
      className: '',
      buttonIndex: 2,
      onClick: () => {
        handleLogin(LoginType.Signup);
      },
    },
    {
      label: ButtonType.Login,
      variant: ButtonVariant.Secondary,
      buttonIndex: 3,
      onClick: () => {
        handleLogin(LoginType.Signin);
      },
      isIconVisible: true,
      iconSrc: userIcon,
    },
  ];
  const dropdownButtonArray = [
    {
      label: displayName,
      onClick: () => {
        return;
      },
    },
    {
      label: 'Update Profile',
      onClick: () => {
        handleProfile();
      },
    },
    {
      label: 'Change Password',
      onClick: () => {
        handleChangePassword();
      },
    },
  ];
  return (
    <Row className="header header-background">
      <Col className="p-0">
        <Header
          brandAlt={headerConstants.brandLogoText}
          brandSrc={headerConstants.brandLogo}
          brandImageAriaLabel={litrals.brandImageAriaLabel}
          brandWidth={headerConstants.brandLogoWidth}
          brandHeight={headerConstants.brandLogoHeight}
          brandURL={headerConstants.brandLogoUrl}
          welcomeMessage={''}
          isButtonVisible
          isBrandVisible
          isMenuVisible
          isRefreshText
          isTopBarHeadingVisible
          brandClassName=""
          refreshText={headerConstants.refreshText}
          refreshTextMobile={headerConstants.refereshTextMobile}
          topBarHeading={
            props.operatorHeaderText
              ? props.operatorHeaderText
              : headerConstants.brandText
          }
          buttonArray={isAuthenticated ? buttonArray : buttonArray2}
          dropdownButtonArray={isAuthenticated && dropdownButtonArray}
          menuArray={
            props.operatorMenuArray
              ? props.operatorMenuArray
              : headerConstants.menuArray
          }
          feedbackArray={
            props.operatorMenuArray ? null : headerConstants.feedbackArray
          }
          thirdPartyPopupBodyProps={headerConstants.thirdPartyPopupBodyProps}
        />
      </Col>
    </Row>
  );
};

export default RenderHeader;
